// Token计费相关的混入
import { deductUserTokens, getUserBalance } from '@/api/auth'

export const tokenMixin = {
  data() {
    return {
      tokenRates: {
        'ai_chat': 1,           // AI对话每次消耗1个token
        'document_parse': 5,    // 文档解析每次消耗5个token
        'ai_render': 10,        // AI渲染每次消耗10个token
        'bim_analysis': 8,      // BIM分析每次消耗8个token
        'knowledge_search': 2,  // 知识库搜索每次消耗2个token
      }
    }
  },
  
  methods: {
    // 计算所需token数
    calculateTokens(usageType, extraParams = {}) {
      const baseRate = this.tokenRates[usageType] || 1
      
      // 根据不同类型计算额外费用
      switch (usageType) {
        case 'ai_chat': {
          // 根据消息长度计算
          const messageLength = extraParams.totalTokens || 0
          return messageLength
        }
        case 'document_parse': {
          // 根据文档大小计算
          const fileSize = extraParams.fileSize || 0 // KB
          return Math.max(5, Math.ceil(fileSize / 1024)) // 每MB消耗1个额外token
        }
        case 'ai_render': {
          // 根据渲染复杂度计算
          const complexity = extraParams.complexity || 'normal'
          const multiplier = { simple: 0.5, normal: 1, complex: 2 }[complexity] || 1
          return Math.ceil(baseRate * multiplier)
        }
        default:
          return baseRate
      }
    },
    
    // 检查余额是否充足
    async checkTokenBalance(requiredTokens) {
      try {
        const userId = this.$store.state.userId
        if (!userId) {
          this.$message.error('请先登录')
          return false
        }

        const response = await getUserBalance(userId)
        console.log('余额检查响应:', response)
        
        const currentBalance = response.remaining_tokens || 0
        console.log('当前余额:', currentBalance, '需要扣费:', requiredTokens)
        
        if (currentBalance < requiredTokens) {
          const result = await this.$confirm(
            `余额不足，需要 ${requiredTokens} tokens，当前余额 ${currentBalance} tokens。是否前往充值？`, 
            '余额不足', 
            {
              confirmButtonText: '去充值',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).catch(() => false)
          
          if (result) {
            this.$router.push('/balance')
          }
          
          return false
        }
        
        return true
      } catch (error) {
        console.error('检查余额失败:', error)
        this.$message.error('检查余额失败')
        return false
      }
    },
    
    // 扣减tokens
    async deductTokens(usageType, description, extraParams = {}) {
      try {
        const userId = this.$store.state.userId
        if (!userId) {
          this.$message.error('请先登录')
          return false
        }

        const requiredTokens = this.calculateTokens(usageType, extraParams)
        
        // 先检查余额
        const hasBalance = await this.checkTokenBalance(requiredTokens)
        if (!hasBalance) {
          return false
        }

        // 执行扣费
        const response = await deductUserTokens(userId, requiredTokens, usageType, description)
        
        if (response.message === '扣减成功') {
          // 显示扣费成功提示
          this.$message.success(`成功扣除 ${requiredTokens} tokens，剩余 ${response.remaining_tokens} tokens`)
          
          // 触发余额更新事件
          this.$emit('balance-updated', response.remaining_tokens)
          
          return {
            success: true,
            tokensUsed: requiredTokens,
            remainingTokens: response.remaining_tokens
          }
        } else {
          this.$message.error(response.message || 'tokens扣费失败')
          return false
        }
      } catch (error) {
        console.error('扣减tokens失败:', error)
        this.$message.error('扣费失败，请重试')
        return false
      }
    },
    // 预估费用（在执行操作前显示给用户）
    estimateCost(usageType, extraParams = {}) {
      return this.calculateTokens(usageType, extraParams)
    },
    
    // 获取用户当前余额
    async getCurrentBalance() {
      try {
        const userId = this.$store.state.userId
        if (!userId) return 0

        const response = await getUserBalance(userId)
        return response.current_tokens || 0
      } catch (error) {
        console.error('获取余额失败:', error)
        return 0
      }
    }
  }
}
